@if (product(); as product) {
  <ui-product-detail-view
    (addToShoppingList)="openAddToShoppingListDialog($event)"
    [product]="product">
  </ui-product-detail-view>
} @else {
  <ui-product-detail-skeleton></ui-product-detail-skeleton>
}

<ui-add-to-shopping-list-dialog></ui-add-to-shopping-list-dialog>
